import React, { FunctionComponent } from "react"
import Typist from "react-typist"

interface ITerminalLineProps {
  delay: number
  hideDelay: number
  title: string
  content: string
}

const TerminalLine: FunctionComponent<ITerminalLineProps> = ({
  delay,
  hideDelay,
  title,
  content,
}) => {
  return (
    <div
      className="mt-2 flex flex-wrap opacity-0"
      style={{
        animation: `.1s linear ${delay}ms forwards reveal, .1s linear ${hideDelay}ms forwards hide`,
      }}
    >
      <span className="text-green-400">{title}</span>
      <p className="flex-1 typing items-center pl-2">
        <Typist cursor={{ blink: true, hideWhenDone: true }}>
          <Typist.Delay ms={delay + 800} />
          {content}
        </Typist>
      </p>
    </div>
  )
}

export default TerminalLine
